// extracted by mini-css-extract-plugin
module.exports = {"container":"ask_e","titleRow":"ask_asl","title":"ask_eg"};